import { supabase } from '../config/supabase';
import { TermsVersion } from '../types/terms';

/**
 * Fetch the currently active terms & conditions version directly from Supabase.
 * Returns null if no active version is set.
 */
export const fetchActiveTermsVersion = async (): Promise<TermsVersion | null> => {
  const { data, error } = await supabase
    .from('terms_versions')
    .select('*')
    .eq('is_active', true)
    .order('effective_date', { ascending: false })
    .maybeSingle();

  if (error) {
    throw new Error(error.message);
  }

  return (data as TermsVersion) ?? null;
};

